import { render, staticRenderFns } from "./UpdateTeamFolder.vue?vue&type=template&id=c2efaed0&scoped=true&"
import script from "./UpdateTeamFolder.vue?vue&type=script&lang=js&"
export * from "./UpdateTeamFolder.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTeamFolder.vue?vue&type=style&index=0&id=c2efaed0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2efaed0",
  null
  
)

export default component.exports